module.exports = __webpack_public_path__ + "static/media/news.d8c3c027.svg";